export const screenSizes = {
  mobile: `(max-width: 900px)`
}
